export const getPercentFromNumber = (total: number, value: number): number =>
  total && value ? (value * total) / 100 : 0;
